import { useTranslation } from 'react-i18next';
import { useCurrentUser } from 'src/queries/user';
import BaoHello from 'src/images/bao/bao-hello.svg?react';
import BackgroundPattern from 'src/components/common/BackgroundPattern';

const FamilyCodeDisplay = () => {
  const { t } = useTranslation();
  const { data: user } = useCurrentUser();

  if (!user) {
    return null;
  }

  const familyCode = user.family.join_code;

  return (
    <div
      data-testid="share-family-code"
      className={
        'relative bg-gradient-to-t from-paywall-darkest-from to-paywall-darkest-to w-full rounded-xl'
      }
    >
      <BackgroundPattern />

      {/* Content */}
      <div className="p-4 flex items-center flex-row text-white">
        <div className="flex-shrink-0 w-14 h-14">
          <BaoHello className="w-full h-full" />
        </div>
        <div className="ml-4 flex-1 flex flex-col">
          <div className="font-bold">
            {t(`profile.familyCode.title.${user.user_type}`)}
          </div>
          <div
            data-testid={'family-code-display'}
            className="font-mono font-bold text-xl"
          >
            {familyCode}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyCodeDisplay;
